import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const ClickToCopy = ({ children, suppressTooltip = false, style, ...rest }) => {
  const element = useRef(null);

  const copyThis = event => {
    const text = element.current.innerText;
    const textArea = document.createElement('textarea');
    textArea.style.position = 'fixed';
    textArea.style.top = 0;
    textArea.style.left = 0;
    textArea.style.width = '2em';
    textArea.style.height = '2em';
    textArea.style.padding = 0;
    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';
    textArea.style.background = 'transparent';
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand('copy');
    } catch (err) {
      console.log('Copy failed', err);
    }

    document.body.removeChild(textArea);
    event.preventDefault();
    event.stopPropagation();
  };

  const parentStyle = {
    borderBottom: '1px dotted #999',
    cursor: 'pointer',
    ...style,
  };

  if (suppressTooltip) {
    return (
      <span {...rest} ref={element} style={parentStyle} onClick={copyThis}>
        {children}
      </span>
    );
  }

  return (
    <OverlayTrigger overlay={<Tooltip>Click to copy</Tooltip>} delay={{ show: 150, hide: 300 }} placement="bottom">
      <span {...rest} ref={element} style={parentStyle} onClick={copyThis}>
        {children}
      </span>
    </OverlayTrigger>
  );
};

ClickToCopy.propTypes = {
  children: PropTypes.any,
  style: PropTypes.object,
  suppressTooltip: PropTypes.bool,
};

export default ClickToCopy;
